function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
            .then(() => {
                console.log('Code copied to clipboard:', text);
            })
            .catch(err => {
                console.error('Failed to copy text to clipboard:', err);
            });
    } else {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // Prevents scrolling to the bottom of the page
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            const success = document.execCommand('copy');
            console.log(success ? 'Code copied to clipboard' : 'Failed to copy text');
        } catch (err) {
            console.error('Fallback: Failed to copy text:', err);
        }
        document.body.removeChild(textarea);
    }
}
